import React , { useState, useEffect, useContext }from 'react';
import './TopBar.scss';
import { Dropdown, Space, Menu } from 'antd';

import { UserOutlined, LogoutOutlined } from '@ant-design/icons'; // Import Ant Design icons
import myImage from '../../assests/dummy.png'
import { Link } from "react-router-dom";
import image  from '../../assests/logo.svg'
import { useNavigate } from 'react-router-dom';
import { UserInfo } from "../../Context/userInfo";
import { useLocation } from 'react-router-dom';
import {getRole} from '../../Helpers/utils'
const TopBar = ({ toggleSidebar,logout1 }) => {
  const location = useLocation();
  const { userData, updateUserData } = useContext(UserInfo);
  const [roles,setRoles]=useState(null)
  const [pageTitle, setPageTitle] = useState('');
  const navigate = useNavigate();
  useEffect(()=>{
    console.log(userData)
if(userData){
  setRoles( getRole(userData.data?.userInfo?.roles))


}


  },[userData])

  useEffect(() => {
    const path = location.pathname;

    switch (true) {
      case path === '/Dashboard':
        setPageTitle('311 Services Reporting Dashboard');
        break;
      case path === '/FAQ':
        setPageTitle('FAQ');
        break;
      case path === '/DataPolicy':
        setPageTitle('Data Policy');
        break;
      case path === '/PluginSupport':
        setPageTitle('Plugin Support');
        break;
      case path === '/Agent-care':
        setPageTitle('Agent Care');
        break;
      case path === '/Call-care-support':
        setPageTitle('Call Care Support');
        break;
      case path === '/publishing-panel':
        setPageTitle('Publishing Panel');
        break;
      case path === '/My-tickets':
        setPageTitle('My Tickets');
        break;
      case path === '/DataService':
        setPageTitle('Data Service');
        break;
      case path === '/Departments':
        setPageTitle('Departments');
        break;

      // Handle the dynamic route `/ticket-detail/:id`
      case path.includes('ticket-detail/'):
        // Extracting the ID using regex
        const ticketId = path.split('/')[2];
        setPageTitle(`Ticket Detail for ID: ${ticketId}`);
        break;

      default:
        setPageTitle('Page Not Found');
        break;
    }
  }, [location.pathname]);



  const items = [
    {
      label: (
        <Space>
          <UserOutlined />
          <span>My-Account</span>
        </Space>
      ),
      key: 'account',

    },
    {
      type: 'divider',
    },
    {
      label: (
        <Space>
          <LogoutOutlined />
          <span>Logout</span>
        </Space>
      ),
      key: 'logout',
      onClick: () => logout1(),

    },
  ];



  return (
    <div className="home-section" style={{ position: 'sticky', display: 'flex', justifyContent: 'space-between', alignItems: 'center',height: '10%' }}>

      <div className="home-content">
        <i className='bx bx-menu' onClick={toggleSidebar} style={{color:'#dfdfdf'}}></i>

      </div>
      <div className="logo-details" style={{ fontFamily: 'Myriad Pro',
                    fontSize: 'xx-large',
                    color: 'whitesmoke',
                    marginRight: 'auto' }}>
      {pageTitle}
      </div>
      <div className="profile-section" style={{display : 'flex' ,marginRight:'3%'}}>
      <i className="bx bx-bell ms-3" style={{ fontSize: '24px', color: 'white', cursor: 'pointer' }}></i>
        <i className="bx bx-phone ms-3" style={{ fontSize: '24px', color: 'white', cursor: 'pointer' }}></i>
        </div>
      <div className="profile-section" style={{display : 'flex' ,marginRight:'2%'}}>

      <div style={{marginTop:'10%',color:'whitesmoke'}}>

        <h5 > <b>{roles} </b></h5> <span> {userData?.data?.userInfo?.email}</span>

        </div>

        <div style={{marginLeft : '19px'}}>
        <Dropdown
          overlay={<Menu items={items} />}
          trigger={['click']}
        >
          <div onClick={(e) => e.preventDefault()}>
            <Space>
            <img
          className='profile-img'
          // src={'data:image/jpeg;base64,'+userData.imageData}
          src={myImage}
          alt="Logo"
        />

            </Space>
          </div>
        </Dropdown>
        </div>

      </div>
    </div>
  );
};

export default TopBar;
